import React from 'react';
import clsx from 'clsx';
import {
  AccidentItemHSP,
  AccidentItemHSPI18n,
} from '@/components/AccidentItemHSP';
import { AccidentListProps } from './AccidentList.types';

/**
 * Komponent wyświetlający listę szkód pojazdu w formie historii
 *
 * @example
 * ```tsx
 * <AccidentList
 *   title="Historia szkód pojazdu"
 *   accidents={accidentData}
 *   showCount={true}
 * />
 * ```
 */
export const AccidentList: React.FC<AccidentListProps> = ({
  accidents,
  title,
  className,
  i18n,
}) => {
  const displayTitle = title || i18n?.title || 'Historia szkód pojazdu';
  const noAccidentsTitle =
    i18n?.noAccidentsTitle || 'Brak zarejestrowanych szkód';
  const noAccidentsDescription =
    i18n?.noAccidentsDescription ||
    'Nie znaleziono żadnych zapisów o szkodach w historii tego pojazdu.';
  const entryNumberPrefix = i18n?.entryNumberPrefix || 'Wpis nr';

  if (!accidents || accidents.length === 0) {
    return (
      <div
        className={clsx(
          'rounded-xl border border-gray-200 bg-white p-6 shadow-sm',
          className,
        )}
      >
        <h3 className="mb-4 font-inter text-lg font-bold text-text-primary">
          {displayTitle}
        </h3>
        <div className="flex flex-col items-center justify-center py-12">
          <div className="mb-4 text-6xl">🚗</div>
          <h4 className="mb-2 font-inter text-xl font-semibold text-text-primary">
            {noAccidentsTitle}
          </h4>
          <p className="font-inter text-sm text-grayText">
            {noAccidentsDescription}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={clsx(className)}>
      <div className="">
        {accidents.map((accident, index) => (
          <div className="relative mx-auto mb-[80px] w-full rounded-card text-center lg:w-[100%] lg:border lg:pt-[130px]">
            <div className="mx-auto flex w-full items-center justify-center gap-2.5 rounded-[50px] bg-primary-100 px-6 py-3 md:absolute md:left-0 md:right-0 md:top-[-20px] lg:w-[200px]">
              <p className="flex-shrink-0 flex-grow-0 text-left text-sm font-medium text-grayText">
                {entryNumberPrefix} {index + 1}
              </p>
            </div>
            <AccidentItemHSP
              key={`accident-${index}-${accident.date}`}
              {...accident}
              className="mx-auto w-[90%] pt-[20px] lg:w-full lg:px-2 xl:px-0 2xl:ml-[-3%] 2xl:w-[106%]"
              i18n={i18n as AccidentItemHSPI18n}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
